import { render } from "./SalesAndReturnPolicy.vue?vue&type=template&id=7c815bd8"
import script from "./SalesAndReturnPolicy.vue?vue&type=script&lang=js"
export * from "./SalesAndReturnPolicy.vue?vue&type=script&lang=js"

import "./SalesAndReturnPolicy.vue?vue&type=style&index=0&id=7c815bd8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__